import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SnigelService } from '@uc/web/core';
import { SeoMetadataService } from '@uc/utilities';
import { ArticleContainerComponent } from '@web/shared/ui';
import { StickyLeadBarRendererComponent } from '@web/shared/feature/feature-sticky-lead-bar';
import { RecommendedUnisCarouselComponent } from '@uc/web/shared/feature/feature-recommended-universities';
import {
	MANAGING_ANXIETY_GUIDE,
	META_DATA,
} from '../../static/guides-managing-anxiety.properties';

@Component({
	selector: 'uc-guides-managing-anxiety',
	templateUrl: './guides-managing-anxiety.component.html',
	imports: [
		ArticleContainerComponent,
		StickyLeadBarRendererComponent,
		RecommendedUnisCarouselComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidesManagingAnxietyComponent implements OnInit {
	guide = MANAGING_ANXIETY_GUIDE;

	constructor(
		private _snigelSrv: SnigelService,
		private _seoSrv: SeoMetadataService,
	) {}

	ngOnInit(): void {
		this.guide.content = this._snigelSrv.insertAdsIntoContent(
			this.guide.content,
		) as string;

		this._seoSrv.updateTitle(META_DATA.title);
		this._seoSrv.updateDescription(META_DATA.description);
	}
}
